/** Reusable loot containers. One recipe draws every state an interactable needs (closed, open). */
import { definePiece } from '../../definePiece';
import type { PieceDefinition } from '../../contract';
import { buildTreasureChest, LOOT_TREASURE_CHEST } from './treasureChest';

export const LOOT_PIECES = {
  treasure_chest: definePiece(LOOT_TREASURE_CHEST, buildTreasureChest, {
    closed: { lid: 'closed', bands: 3, wear: 0.35, moss: 0.3 },
    open: { lid: 'open', bands: 3, wear: 0.35, moss: 0.3 },
    plain_weathered: { lid: 'closed', bands: 2, wear: 1, moss: 1 },
    plain_open: { lid: 'open', bands: 2, wear: 1, moss: 1 },
  }),
} as const satisfies Record<string, PieceDefinition>;
